interface IFD_FORMULA {
  principalAmount: number;
  rateOfInterest: number;
  timePeriod: number;
  timeUnit: 'Monthly' | 'Yearly';
}

export const FD_FORMULA = ({
  principalAmount,
  rateOfInterest,
  timePeriod,
  timeUnit,
}: IFD_FORMULA) => {
  const principal = Number(principalAmount);
  const rate = Number(rateOfInterest);
  const period = Number(timePeriod);

  if (
    principal < 5000 ||
    principal > 1000000000 ||
    rate < 4 ||
    rate > 16 ||
    period < 1 ||
    period > 120
  ) {
    const res = 0;
    return {
      totalInterest: res,
      depositAmount: res,
      maturityAmount: res,
    };
  }

  const n = timeUnit === 'Monthly' ? 12 : 1;
  const t = timeUnit === 'Monthly' ? period / 12 : period; // time in years
  const rateDecimal = rate / 100;

  const maturityAmount = principal * Math.pow(1 + rateDecimal / n, n * t);
  const totalInterest = maturityAmount - principal;

  return {
    totalInterest,
    depositAmount: principal,
    maturityAmount,
  };
};
